import React from 'react';
import { ImagesListBlocLoader, TitleBlocLoader } from 'modules/shared-cms-advanced';
import { LightSeparator } from 'modules/shared-ui/components';
import { NouveautesCatalogueLoader } from 'modules/shared-cms-catalogue/enhanced-blocs/nouveautes-catalogue/nouveautes-catalogue-component-loader';

import styles from './universe-page.module.css';

export const UniverseLoader: React.FC = React.memo(() => {
    return (
        <div className={styles.root}>
            <TitleBlocLoader />
            <div className={styles.categoriesBloc}>
                <ImagesListBlocLoader />
            </div>
            <div className={styles.separator}>
                <LightSeparator />
            </div>
            <NouveautesCatalogueLoader />
        </div>
    );
});
